import React from "react";
import "./CloudMain.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CloudImage from "../../../Assets/Images/Technology/Cloud/Cloud-Image.svg";
import arrowIcon from "../../../Assets/Icons/arrow-right-icon.svg";
import example from "../../../Assets/Icons/Icon Wrapper.svg";

function CloudMain() {
  return (
    <div className="cloud-main">
      <div className="cloud-content">
        <section className="cloud-start">
          <p>
            Modern cloud platforms are not tools you can simply switch to
            replace one with the other. Each one has a different role depending
            on how a product is built, scaled, and maintained. At Quad Theory
            Ltd, we select cloud technologies based on a workflow fit, not
            popularity, so teams know exactly why something is in their stack.
          </p>
        </section>
        {/* Amazon Web Services */}
        <div className="cloud-section">
          <h2>
            <span className="span-1">Amazon Web Services (AWS)</span>
          </h2>
          <p>
            <span className="fw-bold">
              The backbone of complex and high-growth systems
            </span>
            <br />
            <br />
            Often, AWS is used when you need the system to have flexibility,
            resilience, and fine-grained control. It supports huge applications
            that have to manage unpredictable traffic, distributed users and
            complex infrastructure decisions over time.
            <br />
            <br />
            <span>Teams commonly use AWS to:</span>
          </p>
          <ul>
            <li>
              <img src={arrowIcon} alt="" /> host applications that have high
              availability and redundancy
            </li>
            <li>
              <img src={arrowIcon} alt="" /> automatically scale in the case of
              traffic peaks
            </li>
            <li>
              <img src={arrowIcon} alt="" /> execute serverless workloads and
              processing in the background
            </li>
            <li>
              <img src={arrowIcon} alt="" /> integrate features of AI and
              machine learning where necessary
            </li>
          </ul>
          <div className="example">
            <div className="example-st">
              <img src={example} alt="example" />
              <strong> Example:</strong>{" "}
            </div>
            <p>
              A SaaS platform might have its core infrastructure running on AWS,
              managing auto scaling groups to handle sudden growth without
              service disruption.
            </p>
          </div>
        </div>

        {/* Microsoft Azure */}
        <div className="cloud-section">
          <h2>
            <span className="span-1">Microsoft Azure</span>
          </h2>
          <p>
            <span className="fw-bold">
              Built for organisations already living in Microsoft ecosystems
            </span>
            <br />
            <br />
            Azure makes good sense where .NET, Active Directory, or Microsoft
            enterprise tools already constitute a part of everyday operations.
            It is usually chosen when cloud systems need to be connected to
            existing on-premise infrastructures in a secure way.
            <br />
            <br />
            <span>Teams usually use Azure to:</span>
          </p>
          <ul>
            <li>
              <img src={arrowIcon} alt="" /> run hybrid cloud implementations
              using on-premise systems
            </li>
            <li>
              <img src={arrowIcon} alt="" /> automate deployments using
              integrated DevOps pipelines
            </li>
            <li>
              <img src={arrowIcon} alt="" /> manage identity, security and
              access centrally
            </li>
            <li>
              <img src={arrowIcon} alt="" /> have tight integration with SQL
              Server and Power BI
            </li>
          </ul>
          <div className="example">
            <div className="example-st">
              <img src={example} alt="example" />
              <strong> Example:</strong>{" "}
            </div>
            <p>
              A corporate portal could be hosted on Azure App Services and
              securely interfacing with on-premise hosted ERP systems.
            </p>
          </div>
        </div>

        {/* Firebase */}
        <div className="cloud-section">
          <h2>
            <span className="span-1">Firebase</span>
          </h2>
          <p>
            <span className="fw-bold">Speed first, structure later</span>
            <br />
            <br />
            Firebase is typically used when teams want to get things moving
            quickly and validate ideas without having to invest much in
            infrastructure planning upfront. It eliminates a lot of the backend
            overhead of common product needs.
            <br />
            <br />
            <span>Teams use Firebase for:</span>
          </p>
          <ul>
            <li>
              <img src={arrowIcon} alt="" /> updated data in chats or dashboards
              in real time
            </li>
            <li>
              <img src={arrowIcon} alt="" /> ready-made authentication flows
            </li>
            <li>
              <img src={arrowIcon} alt="" /> hosting single page applications
              with minimum configuration
            </li>
            <li>
              <img src={arrowIcon} alt="" /> rapid iteration in early stages of
              the product
            </li>
          </ul>
          <div className="example">
            <div className="example-st">
              <img src={example} alt="example" />
              <strong> Example:</strong>{" "}
            </div>
            <p>
              A startup could have a live chat application up in days using the
              services of Firebase Authentication, Firestore and Hosting without
              ever needing to manage servers.
            </p>
          </div>
        </div>

        {/* Vercel */}
        <div className="cloud-section">
          <h2>
            <span className="span-1">Vercel</span>
          </h2>
          <p>
            <span className="fw-bold">
              Where frontend performance takes precedence
            </span>
            <br />
            <br />
            Vercel is for frontend-heavy applications where speed and user
            experience are the most important aspects of the application.
            Especially works with modern frameworks and API driven
            architectures.
            <br />
            <br />
            <span>Teams choose Vercel to:</span>
          </p>
          <ul>
            <li>
              <img src={arrowIcon} alt="" /> deploy frontend projects
              immediately
            </li>
            <li>
              <img src={arrowIcon} alt="" /> benefit from edge caching at the
              global level
            </li>
            <li>
              <img src={arrowIcon} alt="" /> push update without downtime
            </li>
            <li>
              <img src={arrowIcon} alt="" /> seamlessly integrate with backend
              APIs elsewhere
            </li>
          </ul>
          <div className="example">
            <div className="example-st">
              <img src={example} alt="example" />
              <strong> Example:</strong>{" "}
            </div>
            <p>
              An e-commerce website may also have its frontend running on Vercel
              to make page load times fast and its backend logic running on AWS
              or Firebase cloud services.
            </p>
          </div>
        </div>

        {/* Cloud Image Section */}
        <div className="cloud-image">
          <img
            className="img-fluid"
            src={CloudImage}
            alt="Cloud Tech Diagram"
          />
        </div>
        {/* Developer Combine team */}
        <div className="cloud-section">
          <h2 className="team-title">
            How Our Developers Combine Platforms In Practice
          </h2>
          <p>
            Most products we work on do not fit neatly into one cloud. Different
            parts of the system have very different requirements and trying to
            put everything on one platform usually results in cost or
            performance problems later.
            <br />
            <br />
            <span>A very common pattern we use looks like this:</span>
          </p>
          <ul>
            <li>
              <img src={arrowIcon} alt="" /> Frontend deployed on Vercel for
              high-speed globally delivered and simple updates.
            </li>
            <li>
              <img src={arrowIcon} alt="" /> Backend APIs on AWS Lambda where
              scaling is required along with background jobs and traffic spikes,
              are under tighter control.
            </li>
            <li>
              <img src={arrowIcon} alt="" /> Firebase used selectively for
              authentication or real-time functionality such as notifications or
              live dashboards.
            </li>
          </ul>
          <p>
            <span>
              We also separate heavy and light workloads deliberately:
            </span>
          </p>
          <ul>
            <li>
              <img src={arrowIcon} alt="" /> Long-running processes or
              data-intensive processes to stay on AWS or Azure.
            </li>
            <li>
              <img src={arrowIcon} alt="" /> Lightweight apps, experiments or
              prototypes run in the case of Firebase or simpler cloud setups.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default CloudMain;
